var googleChartsLoaded = false;

function loadGoogleCharts() {
    return new Promise((resolve) => {
        google.charts.load('current', { 'packages': ['corechart'] });
        google.charts.setOnLoadCallback(function () {
            googleChartsLoaded = true;
            resolve();
        });
    });
}
// average price of windscreen wiper
const AveragePriceOfWindscreenWiper = {
    history: window.History,
    buildUpQueryString: function (alt_data) {
        const queryStringData = {};
        $.map(alt_data,
            function (value, key) {
                if (key === "isPageChange")
                    return;
                if (value) {
                    queryStringData[key] = value;
                }
            });
        return $.param(queryStringData).replace(/%5B%5D/g, "");
    },
    getAveragePriceOfWindscreenWiperData: function () {
        // Get the active tab
        var tabValue = $("#average-price-of-windscreen-wiper-tab1, #average-price-of-windscreen-wiper-tab2, #average-price-of-windscreen-wiper-tab3").filter(".active").attr('id');

        // Return a data object with the active tab
        return { tab: tabValue };
    },
    updateResultsAveragePriceOfWindscreenWiperLogic: function (isPageChange) {
        const self = this;
        const data = self.getAveragePriceOfWindscreenWiperData();
        if (isPageChange) {
            data.isPageChange = true;
        }
        self.history.pushState(data, $("title").html(), location.pathname + "?" + self.buildUpQueryString(data));
        return data;
    },
    getChartData: function (state) {
        const self = this;
        $.get("/one-link-average-price-of-windscreen-wiper/get-chart-data", state.data, function (response) {
            self.drawAveragePriceOfWindscreenWiperChartForMonths(state.data.tab, response);
        });
    },
    updateAveragePriceOfWindscreenWiperState: function () {
        const self = this;
        const state = self.history.getState();
        $.get('/one-link-average-price-of-windscreen-wiper/table-results', state.data, function (response) {
            $('[data-one-link-average-price-of-windscreen-wiper-table-results]').replaceWith(response);
        });
        self.getChartData(self.history.getState());
    },
    reloadTable: function (state) {
        const self = this;
        $.get("/one-link-average-price-of-windscreen-wiper/table-results", state.data, function (response) {
            $('[data-one-link-average-price-of-windscreen-wiper-table-results]').replaceWith(response);
        });
    },
    drawAveragePriceOfWindscreenWiperChartForMonths: function (tab, rawData) {
        if (googleChartsLoaded) {
            if ($('#' + tab).hasClass('active')) {
                const self = this;
                var chartId = 'curve_chart-' + tab;
                self.drawAveragePriceOfWindscreenWiperChart(chartId, rawData);
            }
        } else {
            setTimeout(() => this.drawAveragePriceOfWindscreenWiperChartForMonths(tab, rawData), 1000);
        }
    },
    getParameterByName: function (name, url = window.location.href) {
        name = name.replace(/[\[\]]/g, '\\$&');
        var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
            results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, ' '));
    },
    drawAveragePriceOfWindscreenWiperChart: function (chartId, rawData) {
        var columnNames = ['Month', 'Price (£)'];
        var chartData = [columnNames];

        for (var i = 0; i < rawData.length; i++) {
            var dateParts = rawData[i].monthYear.split(" ");
            var year = parseInt(dateParts[1]);
            var monthMapping = { Jan: 0, Feb: 1, Mar: 2, Apr: 3, May: 4, Jun: 5, Jul: 6, Aug: 7, Sept: 8, Oct: 9, Nov: 10, Dec: 11 };
            var month = monthMapping[dateParts[0]];
            var windscreenPrice = rawData[i].averagePriceOfWindscreenWiper ? parseFloat(rawData[i].averagePriceOfWindscreenWiper.toFixed(2)) : null;
            chartData.push([new Date(year, month), windscreenPrice]); // Add price of windscreen wiper
        }
        var data = google.visualization.arrayToDataTable(chartData);

        var options = {
            curveType: 'none',
            vAxis: { format: '£#', minValue: 0 },
            hAxis: {
                format: 'MMM yyyy',
                slantedText: true, // Enable slanted text
                slantedTextAngle: 45, // Set the angle to 45 degrees
                ticks: data.getNumberOfRows() ? data.getDistinctValues(0) : [] // return distinct values from the first column (0 index) of the data
            },
            legend: {
                position: 'top',
                alignment: 'start'
            },
            series: {
                0: { lineWidth: 1, pointSize: 5 },
                1: { lineWidth: 1, pointSize: 5 },
                2: { lineWidth: 1, pointSize: 5 },
                3: { lineWidth: 1, pointSize: 5 }
            },
            chartArea: {
                left: '10%',
                right: '7%',
                top: '10%',
                bottom: '15%',
                width: '100%',
                height: '82%'
            }
        };
        var chartDiv = document.getElementById(chartId);
        if (chartDiv) {
            // Create a chart instance
            var chart = new google.visualization.LineChart(chartDiv);

            // Clear the chart
            chart.clearChart();

            // Draw the chart with options and data.
            chart.draw(data, options);
        }
    },
    setupOneLinkAveragePriceOfWindscreenWiper: function () {
        const self = this;
        $("#average-price-of-windscreen-wiper-tab1, #average-price-of-windscreen-wiper-tab2, #average-price-of-windscreen-wiper-tab3").on('click', function (e) {
            // Stop the browser from following the link
            e.preventDefault();

            // Show the tab
            $(this).tab('show');

            // Update URL
            let url = new URL(window.location.href);
            url.searchParams.set('tab', $(this).attr('id'));
            window.history.replaceState({}, '', url);
        });
        self.getChartData({ data: { tab: 'average-price-of-windscreen-wiper-tab1' } });
        History.Adapter.bind(window, "statechange", self.updateAveragePriceOfWindscreenWiperState());
        window.updateResults = function () {
            self.updateResultsAveragePriceOfWindscreenWiperLogic();
        };
        // Extract tab parameter from URL
        const urlSearchParams = new URLSearchParams(window.location.search);
        let tab = urlSearchParams.get('tab') || 'average-price-of-windscreen-wiper-tab1' || 'average-price-of-windscreen-wiper-tab2';

        // If a tab parameter is found, set this tab to active. Otherwise, default to tab1
        if (tab) {
            $('#' + tab).tab('show');
        } else {
            tab = 'average-price-of-windscreen-wiper-tab1';
            $('#' + tab).tab('show');
        }

        $("#average-price-of-windscreen-wiper-tab1, #average-price-of-windscreen-wiper-tab2, #average-price-of-windscreen-wiper-tab3").on('shown.bs.tab', function (e) {
            const tab = $(this).attr('id');
            // Only fetch the chart data after the tab has been shown
            if ($('#' + tab).hasClass('active')) {
                const state = { data: { tab: tab } };
                self.getChartData(state);
                self.reloadTable(state); // Update to pass full state
            }
        });

        $('#' + tab).tab('show');

        const state = { data: { tab: tab } };
        self.getChartData(state);
        setTimeout(function () { self.reloadTable(state); }, 200); // delay of 200ms
        google.charts.load('current', { 'packages': ['corechart'] });
    },
};

// average price of clutch
const AveragePriceOfClutch = {
    history: window.History,
    buildUpQueryString: function (alt_data) {
        const queryStringData = {};
        $.map(alt_data,
            function (value, key) {
                if (key === "isPageChange")
                    return;
                if (value) {
                    queryStringData[key] = value;
                }
            });
        return $.param(queryStringData).replace(/%5B%5D/g, "");
    },
    getAveragePriceOfClutchData: function () {
        // Get the active tab
        var tabValue = $("#average-price-of-clutch-tab1, #average-price-of-clutch-tab2, #average-price-of-clutch-tab3").filter(".active").attr('id');

        // Return a data object with the active tab
        return { tab: tabValue };
    },
    updateResultsAveragePriceOfClutchLogic: function (isPageChange) {
        const self = this;
        const data = self.getAveragePriceOfClutchData();
        if (isPageChange) {
            data.isPageChange = true;
        }
        self.history.pushState(data, $("title").html(), location.pathname + "?" + self.buildUpQueryString(data));
        return data;
    },
    getChartData: function (state) {
        const self = this;
        $.get("/one-link-average-price-of-clutch/get-chart-data", state.data, function (response) {
            self.drawAveragePriceOfClutchChartForMonths(state.data.tab, response);
        });
    },
    updateAveragePriceOfClutchState: function () {
        const self = this;
        const state = self.history.getState();
        $.get('/one-link-average-price-of-clutch/table-results', state.data, function (response) {
            $('[data-one-link-average-price-of-clutch-table-results]').replaceWith(response);
        });
        self.getChartData(self.history.getState());
    },
    reloadTable: function (state) {
        const self = this;
        $.get("/one-link-average-price-of-clutch/table-results", state.data, function (response) {
            $('[data-one-link-average-price-of-clutch-table-results]').replaceWith(response);
        });
    },
    drawAveragePriceOfClutchChartForMonths: function (tab, rawData) {
        if (googleChartsLoaded) {
            if ($('#' + tab).hasClass('active')) {
                const self = this;
                var chartId = 'curve_chart-' + tab;
                self.drawAveragePriceOfClutchChart(chartId, rawData);
            }
        } else {
            setTimeout(() => this.drawAveragePriceOfClutchChartForMonths(tab, rawData), 1000);
        }
    },
    getParameterByName: function (name, url = window.location.href) {
        name = name.replace(/[\[\]]/g, '\\$&');
        var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
            results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, ' '));
    },
    drawAveragePriceOfClutchChart: function (chartId, rawData) {
        var columnNames = ['Month', 'Price (£)'];
        var chartData = [columnNames];

        for (var i = 0; i < rawData.length; i++) {
            var dateParts = rawData[i].monthYear.split(" ");
            var year = parseInt(dateParts[1]);
            var monthMapping = { Jan: 0, Feb: 1, Mar: 2, Apr: 3, May: 4, Jun: 5, Jul: 6, Aug: 7, Sept: 8, Oct: 9, Nov: 10, Dec: 11 };
            var month = monthMapping[dateParts[0]];
            var clutch = rawData[i].averagePriceOfClutch ? parseFloat(rawData[i].averagePriceOfClutch.toFixed(2)) : null;
            chartData.push([new Date(year, month), clutch]); // Add price of clutch
        }
        var data = google.visualization.arrayToDataTable(chartData);

        var options = {
            curveType: 'none',
            vAxis: { format: '£#', minValue: 0 },
            hAxis: {
                format: 'MMM yyyy',
                slantedText: true, // Enable slanted text
                slantedTextAngle: 45, // Set the angle to 45 degrees
                ticks: data.getNumberOfRows() ? data.getDistinctValues(0) : [] // return distinct values from the first column (0 index) of the data
            },
            legend: {
                position: 'top',
                alignment: 'start'
            },
            series: {
                0: { lineWidth: 1, pointSize: 5 },
                1: { lineWidth: 1, pointSize: 5 },
                2: { lineWidth: 1, pointSize: 5 },
                3: { lineWidth: 1, pointSize: 5 }
            },
            chartArea: {
                left: '10%',
                right: '7%',
                top: '10%',
                bottom: '15%',
                width: '100%',
                height: '82%'
            }
        };
        var chartDiv = document.getElementById(chartId);
        if (chartDiv) {
            // Create a chart instance
            var chart = new google.visualization.LineChart(chartDiv);

            // Clear the chart
            chart.clearChart();

            // Draw the chart with options and data.
            chart.draw(data, options);
        }
    },
    setupOneLinkAveragePriceOfClutch: function () {
        const self = this;
        $("#average-price-of-clutch-tab1, #average-price-of-clutch-tab2, #average-price-of-clutch-tab3").on('click', function (e) {
            // Stop the browser from following the link
            e.preventDefault();

            // Show the tab
            $(this).tab('show');

            // Update URL
            let url = new URL(window.location.href);
            url.searchParams.set('tab', $(this).attr('id'));
            window.history.replaceState({}, '', url);
        });
        self.getChartData({ data: { tab: 'average-price-of-clutch-tab1' } });
        History.Adapter.bind(window, "statechange", self.updateAveragePriceOfClutchState());
        window.updateResults = function () {
            self.updateResultsAveragePriceOfClutchLogic();
        };
        // Extract tab parameter from URL
        const urlSearchParams = new URLSearchParams(window.location.search);
        let tab = urlSearchParams.get('tab') || 'average-price-of-clutch-tab1' || 'average-price-of-clutch-tab2';

        // If a tab parameter is found, set this tab to active. Otherwise, default to tab1
        if (tab) {
            $('#' + tab).tab('show');
        } else {
            tab = 'average-price-of-clutch-tab1';
            $('#' + tab).tab('show');
        }

        $("#average-price-of-clutch-tab1, #average-price-of-clutch-tab2, #average-price-of-clutch-tab3").on('shown.bs.tab', function (e) {
            const tab = $(this).attr('id');
            // Only fetch the chart data after the tab has been shown
            if ($('#' + tab).hasClass('active')) {
                const state = { data: { tab: tab } };
                self.getChartData(state);
                self.reloadTable(state); // Update to pass full state
            }
        });

        $('#' + tab).tab('show');

        const state = { data: { tab: tab } };
        self.getChartData(state);
        setTimeout(function () { self.reloadTable(state); }, 200); // delay of 200ms
        google.charts.load('current', { 'packages': ['corechart'] });
    },
};

// average price of front disc
const AveragePriceOfFrontDisc = {
    history: window.History,
    buildUpQueryString: function (alt_data) {
        const queryStringData = {};
        $.map(alt_data,
            function (value, key) {
                if (key === "isPageChange")
                    return;
                if (value) {
                    queryStringData[key] = value;
                }
            });
        return $.param(queryStringData).replace(/%5B%5D/g, "");
    },
    getAveragePriceOfFrontDiscData: function () {
        // Get the active tab
        var tabValue = $("#average-price-of-front-disc-tab1, #average-price-of-front-disc-tab2, #average-price-of-front-disc-tab3").filter(".active").attr('id');

        // Return a data object with the active tab
        return { tab: tabValue };
    },
    updateResultsAveragePriceOfFrontDiscLogic: function (isPageChange) {
        const self = this;
        const data = self.getAveragePriceOfFrontDiscData();
        if (isPageChange) {
            data.isPageChange = true;
        }
        self.history.pushState(data, $("title").html(), location.pathname + "?" + self.buildUpQueryString(data));
        return data;
    },
    getChartData: function (state) {
        const self = this;
        $.get("/one-link-average-price-of-front-disc/get-chart-data", state.data, function (response) {
            self.drawAveragePriceOfFrontDiscChartForMonths(state.data.tab, response);
        });
    },
    updateAveragePriceOfFrontDiscState: function () {
        const self = this;
        const state = self.history.getState();
        $.get('/one-link-average-price-of-front-disc/table-results', state.data, function (response) {
            $('[data-one-link-average-price-of-front-disc-table-results]').replaceWith(response);
        });
        self.getChartData(self.history.getState());
    },
    reloadTable: function (state) {
        const self = this;
        $.get("/one-link-average-price-of-front-disc/table-results", state.data, function (response) {
            $('[data-one-link-average-price-of-front-disc-table-results]').replaceWith(response);
        });
    },
    drawAveragePriceOfFrontDiscChartForMonths: function (tab, rawData) {
        if (googleChartsLoaded) {
            if ($('#' + tab).hasClass('active')) {
                const self = this;
                var chartId = 'curve_chart-' + tab;
                self.drawAveragePriceOfFrontDiscChart(chartId, rawData);
            }
        } else {
            setTimeout(() => this.drawAveragePriceOfFrontDiscChartForMonths(tab, rawData), 1000);
        }
    },
    getParameterByName: function (name, url = window.location.href) {
        name = name.replace(/[\[\]]/g, '\\$&');
        var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
            results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, ' '));
    },
    drawAveragePriceOfFrontDiscChart: function (chartId, rawData) {
        var columnNames = ['Month', 'Price (£)'];
        var chartData = [columnNames];

        for (var i = 0; i < rawData.length; i++) {
            var dateParts = rawData[i].monthYear.split(" ");
            var year = parseInt(dateParts[1]);
            var monthMapping = { Jan: 0, Feb: 1, Mar: 2, Apr: 3, May: 4, Jun: 5, Jul: 6, Aug: 7, Sept: 8, Oct: 9, Nov: 10, Dec: 11 };
            var month = monthMapping[dateParts[0]];
            var frontDisc = rawData[i].averagePriceOfFrontDisc ? parseFloat(rawData[i].averagePriceOfFrontDisc.toFixed(2)) : null;
            chartData.push([new Date(year, month), frontDisc]); // Add price of front disc
        }
        var data = google.visualization.arrayToDataTable(chartData);

        var options = {
            curveType: 'none',
            vAxis: { format: '£#', minValue: 0 },
            hAxis: {
                format: 'MMM yyyy',
                slantedText: true, // Enable slanted text
                slantedTextAngle: 45, // Set the angle to 45 degrees
                ticks: data.getNumberOfRows() ? data.getDistinctValues(0) : [] // return distinct values from the first column (0 index) of the data
            },
            legend: {
                position: 'top',
                alignment: 'start'
            },
            series: {
                0: { lineWidth: 1, pointSize: 5 },
                1: { lineWidth: 1, pointSize: 5 },
                2: { lineWidth: 1, pointSize: 5 },
                3: { lineWidth: 1, pointSize: 5 }
            },
            chartArea: {
                left: '10%',
                right: '7%',
                top: '10%',
                bottom: '15%',
                width: '100%',
                height: '82%'
            }
        };

        var chartDiv = document.getElementById(chartId);
        if (chartDiv) {
            var chart = new google.visualization.LineChart(chartDiv);
            chart.clearChart();
            chart.draw(data, options);
        }
    },
    setupOneLinkAveragePriceOfFrontDisc: function () {
        const self = this;
        $("#average-price-of-front-disc-tab1, #average-price-of-front-disc-tab2, #average-price-of-front-disc-tab3").on('click', function (e) {
            // Stop the browser from following the link
            e.preventDefault();

            // Show the tab
            $(this).tab('show');

            // Update URL
            let url = new URL(window.location.href);
            url.searchParams.set('tab', $(this).attr('id'));
            window.history.replaceState({}, '', url);
        });
        self.getChartData({ data: { tab: 'average-price-of-front-disc-tab1' } });
        History.Adapter.bind(window, "statechange", self.updateAveragePriceOfFrontDiscState());
        window.updateResults = function () {
            self.updateResultsAveragePriceOfFrontDiscLogic();
        };
        // Extract tab parameter from URL
        const urlSearchParams = new URLSearchParams(window.location.search);
        let tab = urlSearchParams.get('tab') || 'average-price-of-front-disc-tab1' || 'average-price-of-front-disc-tab2';

        // If a tab parameter is found, set this tab to active. Otherwise, default to tab1
        if (tab) {
            $('#' + tab).tab('show');
        } else {
            tab = 'average-price-of-front-disc-tab1';
            $('#' + tab).tab('show');
        }

        $("#average-price-of-front-disc-tab1, #average-price-of-front-disc-tab2, #average-price-of-front-disc-tab3").on('shown.bs.tab', function (e) {
            const tab = $(this).attr('id');
            // Only fetch the chart data after the tab has been shown
            if ($('#' + tab).hasClass('active')) {
                const state = { data: { tab: tab } };
                self.getChartData(state);
                self.reloadTable(state); // Update to pass full state
            }
        });

        $('#' + tab).tab('show');

        const state = { data: { tab: tab } };
        self.getChartData(state);
        setTimeout(function () { self.reloadTable(state); }, 200); // delay of 200ms
        google.charts.load('current', { 'packages': ['corechart'] });
    },
};

// percentage of all smr jobs in franchise
const PercentageOfAllSMRJobsInFranchise = {
    history: window.History,
    buildUpQueryString: function (alt_data) {
        const queryStringData = {};
        $.map(alt_data,
            function (value, key) {
                if (key === "isPageChange")
                    return;
                if (value) {
                    queryStringData[key] = value;
                }
            });
        return $.param(queryStringData).replace(/%5B%5D/g, "");
    },
    getPercentageOfAllSMRJobsInFranchiseData: function () {
        // Get the active tab
        var tabValue = $("#percentage-of-all-smr-jobs-in-franchise-tab1, #percentage-of-all-smr-jobs-in-franchise-tab2, #percentage-of-all-smr-jobs-in-franchise-tab3").filter(".active").attr('id');

        // Return a data object with the active tab
        return { tab: tabValue };
    },
    updateResultsPercentageOfAllSMRJobsInFranchiseLogic: function (isPageChange) {
        const self = this;
        const data = self.getPercentageOfAllSMRJobsInFranchiseData();
        if (isPageChange) {
            data.isPageChange = true;
        }
        self.history.pushState(data, $("title").html(), location.pathname + "?" + self.buildUpQueryString(data));
        return data;
    },
    getChartData: function (state) {
        const self = this;
        $.get("/one-link-percentage-of-all-smr-jobs-in-franchise/get-chart-data", state.data, function (response) {
            self.drawPercentageOfAllSMRJobsInFranchiseChartForMonths(state.data.tab, response);
        });
    },
    updatePercentageOfAllSMRJobsInFranchiseState: function () {
        const self = this;
        const state = self.history.getState();
        $.get('/one-link-percentage-of-all-smr-jobs-in-franchise/table-results', state.data, function (response) {
            $('[data-one-link-percentage-of-all-smr-jobs-in-franchise-table-results]').replaceWith(response);
        });
        self.getChartData(self.history.getState());
    },
    reloadTable: function (state) {
        const self = this;
        $.get("/one-link-percentage-of-all-smr-jobs-in-franchise/table-results", state.data, function (response) {
            $('[data-one-link-percentage-of-all-smr-jobs-in-franchise-table-results]').replaceWith(response);
        });
    },
    drawPercentageOfAllSMRJobsInFranchiseChartForMonths: function (tab, rawData) {
        if (googleChartsLoaded) {
            if ($('#' + tab).hasClass('active')) {
                const self = this;
                var chartId = 'curve_chart-' + tab;
                self.drawPercentageOfAllSMRJobsInFranchiseChart(chartId, rawData);
            }
        } else {
            setTimeout(() => this.drawPercentageOfAllSMRJobsInFranchiseChartForMonths(tab, rawData), 1000);
        }
    },
    getParameterByName: function (name, url = window.location.href) {
        name = name.replace(/[\[\]]/g, '\\$&');
        var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
            results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, ' '));
    },
    drawPercentageOfAllSMRJobsInFranchiseChart: function (chartId, rawData) {
        var columnNames = ['Month', 'Percentage of all SMR jobs undertaken in franchised outlets, excluding tyres (%)'];
        var chartData = [columnNames];

        for (var i = 0; i < rawData.length; i++) {
            var dateParts = rawData[i].monthYear.split(" ");
            var year = parseInt(dateParts[1]);
            var monthMapping = { Jan: 0, Feb: 1, Mar: 2, Apr: 3, May: 4, Jun: 5, Jul: 6, Aug: 7, Sept: 8, Oct: 9, Nov: 10, Dec: 11 };
            var month = monthMapping[dateParts[0]];
            var smrInFranchise = rawData[i].percentageOfAllSMRInFranchise ? parseFloat(rawData[i].percentageOfAllSMRInFranchise.toFixed(2)) : null;
            chartData.push([new Date(year, month), smrInFranchise]); // Add % of all smr jobs in franchise
        }
        var data = google.visualization.arrayToDataTable(chartData);
        var options = {
            curveType: 'none',
            vAxis: { 
                format: '#\'%\'',
                minValue: 0
            },
            hAxis: {
                format: 'MMM yyyy',
                slantedText: true, // Enable slanted text
                slantedTextAngle: 45, // Set the angle to 45 degrees
                ticks: data.getNumberOfRows() ? data.getDistinctValues(0) : []
            },
            legend: {
                position: 'top',
                alignment: 'start'
            },
            series: {
                0: { lineWidth: 1, pointSize: 5 },
                1: { lineWidth: 1, pointSize: 5 },
                2: { lineWidth: 1, pointSize: 5 },
                3: { lineWidth: 1, pointSize: 5 }
            },
            chartArea: {
                left: '10%',
                right: '7%',
                top: '10%',
                bottom: '15%',
                width: '100%',
                height: '82%'
            }
        };

        var chartDiv = document.getElementById(chartId);
        if (chartDiv) {
            // Create a chart instance
            var chart = new google.visualization.LineChart(chartDiv);

            // Clear the chart
            chart.clearChart();

            // Draw the chart with options and data.
            chart.draw(data, options);
        }
    },
    setupOneLinkPercentageOfAllSMRJobsInFranchise: function () {
        const self = this;
        $("#percentage-of-all-smr-jobs-in-franchise-tab1, #percentage-of-all-smr-jobs-in-franchise-tab2, #percentage-of-all-smr-jobs-in-franchise-tab3").on('click', function (e) {
            // Stop the browser from following the link
            e.preventDefault();

            // Show the tab
            $(this).tab('show');

            // Update URL
            let url = new URL(window.location.href);
            url.searchParams.set('tab', $(this).attr('id'));
            window.history.replaceState({}, '', url);
        });
        self.getChartData({ data: { tab: 'percentage-of-all-smr-jobs-in-franchise-tab2' } });
        History.Adapter.bind(window, "statechange", self.updatePercentageOfAllSMRJobsInFranchiseState());
        window.updateResults = function () {
            self.updateResultsPercentageOfAllSMRJobsInFranchiseLogic();
        };
        // Extract tab parameter from URL
        const urlSearchParams = new URLSearchParams(window.location.search);
        let tab = urlSearchParams.get('tab') || 'percentage-of-all-smr-jobs-in-franchise-tab2' || 'percentage-of-all-smr-jobs-in-franchise-tab1';

        // If a tab parameter is found, set this tab to active. Otherwise, default to tab1
        if (tab) {
            $('#' + tab).tab('show');
        } else {
            tab = 'percentage-of-all-smr-jobs-in-franchise-tab2';
            $('#' + tab).tab('show');
        }

        $("#percentage-of-all-smr-jobs-in-franchise-tab1, #percentage-of-all-smr-jobs-in-franchise-tab2, #percentage-of-all-smr-jobs-in-franchise-tab3").on('shown.bs.tab', function (e) {
            const tab = $(this).attr('id');
            // Only fetch the chart data after the tab has been shown
            if ($('#' + tab).hasClass('active')) {
                const state = { data: { tab: tab } };
                self.getChartData(state);
                self.reloadTable(state); // Update to pass full state
            }
        });

        $('#' + tab).tab('show');

        const state = { data: { tab: tab } };
        self.getChartData(state);
        setTimeout(function () { self.reloadTable(state); }, 200); // delay of 200ms
        google.charts.load('current', { 'packages': ['corechart'] });
    },
};

// average cost of service - car
const AverageCostOfServiceCar = {
    history: window.History,
    buildUpQueryString: function (alt_data) {
        const queryStringData = {};
        $.map(alt_data,
            function (value, key) {
                if (key === "isPageChange")
                    return;
                if (value) {
                    queryStringData[key] = value;
                }
            });
        return $.param(queryStringData).replace(/%5B%5D/g, "");
    },
    getAverageCostOfServiceCarData: function () {
        // Get the active tab
        var tabValue = $("#average-cost-of-service-tab1, #average-cost-of-service-tab2, #average-cost-of-service-tab3").filter(".active").attr('id');

        // Return a data object with the active tab
        return { tab: tabValue };
    },
    updateResultsAverageCostOfServiceCarLogic: function (isPageChange) {
        const self = this;
        const data = self.getAverageCostOfServiceCarData();
        if (isPageChange) {
            data.isPageChange = true;
        }
        self.history.pushState(data, $("title").html(), location.pathname + "?" + self.buildUpQueryString(data));
        return data;
    },
    getChartData: function (state) {
        const self = this;
        $.get("/one-link-average-cost-of-service/get-chart-data", state.data, function (response) {
            self.drawAverageCostOfServiceCarChartForMonths(state.data.tab, response);
        });
    },
    updateAverageCostOfServiceCarState: function () {
        const self = this;
        const state = self.history.getState();
        $.get('/one-link-average-cost-of-service/table-results', state.data, function (response) {
            $('[data-one-link-average-cost-of-service-table-results]').replaceWith(response);
        });
        self.getChartData(self.history.getState());
    },
    reloadTable: function (state) {
        const self = this;
        $.get("/one-link-average-cost-of-service/table-results", state.data, function (response) {
            $('[data-one-link-average-cost-of-service-table-results]').replaceWith(response);
        });
    },
    drawAverageCostOfServiceCarChartForMonths: function (tab, rawData) {
        if (googleChartsLoaded) {
            if ($('#' + tab).hasClass('active')) {
                const self = this;
                var chartId = 'curve_chart-' + tab;
                self.drawAverageCostOfServiceCarChart(chartId, rawData);
            }
        } else {
            setTimeout(() => this.drawAverageCostOfServiceCarChartForMonths(tab, rawData), 1000);
        }
    },
    getParameterByName: function (name, url = window.location.href) {
        name = name.replace(/[\[\]]/g, '\\$&');
        var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
            results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, ' '));
    },
    drawAverageCostOfServiceCarChart: function (chartId, rawData) {
        var columnNames = ['Month', 'Average cost of a car service (£)'];
        var chartData = [columnNames];

        for (var i = 0; i < rawData.length; i++) {
            var dateParts = rawData[i].monthYear.split(" ");
            var year = parseInt(dateParts[1]);
            var monthMapping = { Jan: 0, Feb: 1, Mar: 2, Apr: 3, May: 4, Jun: 5, Jul: 6, Aug: 7, Sept: 8, Oct: 9, Nov: 10, Dec: 11 };
            var month = monthMapping[dateParts[0]];
            var carCostOfService = rawData[i].averageCarCostOfService ? parseFloat(rawData[i].averageCarCostOfService.toFixed(2)) : null;
            chartData.push([new Date(year, month), carCostOfService]); 
        }
        var data = google.visualization.arrayToDataTable(chartData);

        var options = {
            curveType: 'none',
            vAxis: { format: '£#', minValue: 0 },
            hAxis: {
                format: 'MMM yyyy',
                slantedText: true, // Enable slanted text
                slantedTextAngle: 45, // Set the angle to 45 degrees
                ticks: data.getNumberOfRows() ? data.getDistinctValues(0) : []
            },
            legend: {
                position: 'top',
                alignment: 'start'
            },
            series: {
                0: { lineWidth: 1, pointSize: 5 },
                1: { lineWidth: 1, pointSize: 5 },
                2: { lineWidth: 1, pointSize: 5 },
                3: { lineWidth: 1, pointSize: 5 }
            },
            chartArea: {
                left: '10%',
                right: '7%',
                top: '10%',
                bottom: '15%',
                width: '100%',
                height: '82%'
            }
        };
        var chartDiv = document.getElementById(chartId);
        if (chartDiv) {
            // Create a chart instance
            var chart = new google.visualization.LineChart(chartDiv);

            // Clear the chart
            chart.clearChart();

            // Draw the chart with options and data.
            chart.draw(data, options);
        }
    },
    setupOneLinkAverageCostOfServiceCar: function () {
        const self = this;
        $("#average-cost-of-service-tab1, #average-cost-of-service-tab2, #average-cost-of-service-tab3").on('click', function (e) {
            // Stop the browser from following the link
            e.preventDefault();

            // Show the tab
            $(this).tab('show');

            // Update URL
            let url = new URL(window.location.href);
            url.searchParams.set('tab', $(this).attr('id'));
            window.history.replaceState({}, '', url);
        });
        self.getChartData({ data: { tab: 'average-cost-of-service-tab2' } });
        History.Adapter.bind(window, "statechange", self.updateAverageCostOfServiceCarState());
        window.updateResults = function () {
            self.updateResultsAverageCostOfServiceCarLogic();
        };
        // Extract tab parameter from URL
        const urlSearchParams = new URLSearchParams(window.location.search);
        let tab = urlSearchParams.get('tab') || 'average-cost-of-service-tab2' || 'average-cost-of-service-tab1';

        // If a tab parameter is found, set this tab to active. Otherwise, default to tab1
        if (tab) {
            $('#' + tab).tab('show');
        } else {
            tab = 'average-cost-of-service-tab2';
            $('#' + tab).tab('show');
        }

        $("#average-cost-of-service-tab1, #average-cost-of-service-tab2, #average-cost-of-service-tab3").on('shown.bs.tab', function (e) {
            const tab = $(this).attr('id');
            // Only fetch the chart data after the tab has been shown
            if ($('#' + tab).hasClass('active')) {
                const state = { data: { tab: tab } };
                self.getChartData(state);
                self.reloadTable(state); // Update to pass full state
            }
        });

        $('#' + tab).tab('show');

        const state = { data: { tab: tab } };
        self.getChartData(state);
        setTimeout(function () { self.reloadTable(state); }, 200); // delay of 200ms
        google.charts.load('current', { 'packages': ['corechart'] });
    },
};

// Average cost of service
const AverageCostOfService = {
    history: window.History,
    buildUpQueryString: function (nv_data) {
        const queryStringData = {};
        $.map(nv_data,
            function (value, key) {
                if (key === "isPageChange")
                    return;
                if (value) {
                    queryStringData[key] = value;
                }
            });
        return $.param(queryStringData).replace(/%5B%5D/g, "");
    },

    getAverageCostOfServiceData: function () {
        const dataArray = $("[data-one-link-average-cost-of-service-query-attributes] :input").serializeArray();
        const data = {};
        dataArray.map(function (item) {
            if (data[item.name]) {
                if (typeof (data[item.name]) === "string") {
                    data[item.name] = [data[item.name]];
                }
                data[item.name].push(item.value);
            } else {
                data[item.name] = item.value;
            }
        });

        // Get the active tab
        var tabValue = $("#average-cost-of-service-tab1, #average-cost-of-service-tab2, #average-cost-of-service-tab3").filter(".active").attr('id');
        // Add the active tab to the data
        data.tab = tabValue;
        data.VehicleType = $('#VehicleType').val() || null;
        return data;
    },

    updateResultsAverageCostOfServiceLogic: function (isPageChange) {
        const self = this;
        const data = self.getAverageCostOfServiceData();
        if (isPageChange) {
            data.isPageChange = true;
        }
        self.history.pushState(data, $("title").html(), location.pathname + "?" + self.buildUpQueryString(data));
        return data;
    },

    reloadQuery: function () {
        const self = this;
        const state = self.history.getState();
        $.get('/one-link-average-cost-of-service/query', state.data, function (response) {
            $('[data-one-link-average-cost-of-service-query-attributes]').replaceWith(response);
        });
    },
    reloadTable: function (state) {
        const self = this;
        $.get("/one-link-average-cost-of-service/table-results", state.data, function (response) {
            $('[data-one-link-average-cost-of-service-table-results]').replaceWith(response);
        });
    },
    getAverageCostOfServiceChartData: function (state) {
        const self = this;
        $.get("/one-link-average-cost-of-service/get-chart-data", state.data, function (response) {
            console.log("Inside getAverageCostOfServiceChartData of CostOfService");
            console.log("age: " + response);
            self.drawAverageCostOfServiceChartForMonths(state.data.tab, response);
        });
    },

    updateAverageCostOfServiceState: function () {
        const self = this;
        self.reloadQuery();
        const state = self.history.getState();
        $.get('/one-link-average-cost-of-service/table-results', state.data, function (response) {
            $('[data-one-link-average-cost-of-service-table-results]').replaceWith(response);
        });
        self.getAverageCostOfServiceChartData(self.history.getState());
    },

    drawAverageCostOfServiceChartForMonths: function (tab, drawAverageCostOfServiceChart) {
        if (googleChartsLoaded) {
            if ($('#' + tab).hasClass('active')) {
                const self = this;
                var costOfServiceChartId = 'curve_chart-' + tab;
                self.drawAverageCostOfServiceChart(costOfServiceChartId, drawAverageCostOfServiceChart);
            }
        } else {
            setTimeout(() => this.drawAverageCostOfServiceChartForMonths(tab, drawAverageCostOfServiceChart), 1000);
        }
    },

    getParameterByName: function (name, url = window.location.href) {
        name = name.replace(/[\[\]]/g, '\\$&');
        var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
            results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, ' '));
    },

    drawAverageCostOfServiceChart: function (costOfServiceChartId, rawDataAverageCostOfService) {
        const self = this;
        var columnNames = ['Month', 'Cars (£)', 'Vans (£)'];
        var selectedVehicleType = (self.getParameterByName('VehicleType') || 'all').toLowerCase();
        if (selectedVehicleType !== 'all') {
            var vehicleTypes = ['cars', 'vans'];
            var index = vehicleTypes.indexOf(selectedVehicleType);
            columnNames = ['Month', columnNames[index + 1]];
        }
        var chartData = [columnNames];

        for (var i = 0; i < rawDataAverageCostOfService.length; i++) {
            var dateParts = rawDataAverageCostOfService[i].monthYear.split(" ");
            var year = parseInt(dateParts[1]);
            var monthMapping = { Jan: 0, Feb: 1, Mar: 2, Apr: 3, May: 4, Jun: 5, Jul: 6, Aug: 7, Sept: 8, Oct: 9, Nov: 10, Dec: 11 };
            var month = monthMapping[dateParts[0]];
            var vehicleTypeMapping = {
                'cars': 'averageCarCostOfService',
                'vans': 'averageVanCostOfService'
            };

            if (selectedVehicleType === 'all') {
                chartData.push([
                    new Date(year, month),
                    rawDataAverageCostOfService[i].averageCarCostOfService ? parseFloat(rawDataAverageCostOfService[i].averageCarCostOfService.toFixed(2)) : null,
                    rawDataAverageCostOfService[i].averageVanCostOfService ? parseFloat(rawDataAverageCostOfService[i].averageVanCostOfService.toFixed(2)) : null
                ]);
            } else if (rawDataAverageCostOfService[i].hasOwnProperty(vehicleTypeMapping[selectedVehicleType])) {
                chartData.push([
                    new Date(year, month),
                    rawDataAverageCostOfService[i][vehicleTypeMapping[selectedVehicleType]] ? parseFloat(rawDataAverageCostOfService[i][vehicleTypeMapping[selectedVehicleType]].toFixed(2)) : null
                ]);
            }

        }
        var data = google.visualization.arrayToDataTable(chartData);

        var options = {
            curveType: 'none',
            vAxis: { format: '£#', minValue: 0 },
            hAxis: {
                format: 'MMM yyyy',
                slantedText: true, // Enable slanted text
                slantedTextAngle: 45, // Set the angle to 45 degrees
                ticks: data.getNumberOfRows() ? data.getDistinctValues(0) : []
            },
            legend: {
                position: 'top',
                alignment: 'start'
            },
            series: {
                0: { lineWidth: 1, pointSize: 5 },
                1: { lineWidth: 1, pointSize: 5 },
                2: { lineWidth: 1, pointSize: 5 },
                3: { lineWidth: 1, pointSize: 5 }
            },
            chartArea: {
                left: '10%',
                right: '7%',
                top: '10%',
                bottom: '15%',
                width: '100%',
                height: '82%'
            }
        };
        var costOfServiceChartDiv = document.getElementById(costOfServiceChartId);
        if (costOfServiceChartDiv) {
            // Create a chart instance
            var costOfServiceChart = new google.visualization.LineChart(costOfServiceChartDiv);

            // Clear the chart
            costOfServiceChart.clearChart();

            // Draw the chart with options and data.
            costOfServiceChart.draw(data, options);
        }
    },

    setupOneLinkAverageCostOfService: function () {
        const self = this;
        const VehicleType = self.getParameterByName('VehicleType');
        $(document).on("change",
            "[data-one-link-average-cost-of-service-query-attributes] input, [data-one-link-average-cost-of-service-query-attributes] select",
            () => self.updateResultsAverageCostOfServiceLogic());

        $("#average-cost-of-service-tab1, #average-cost-of-service-tab2, #average-cost-of-service-tab3").on('click', function (e) {
            // Stop the browser from following the link
            e.preventDefault();

            // Show the tab
            $(this).tab('show');

            // Update URL
            let url = new URL(window.location.href);
            url.searchParams.set('tab', $(this).attr('id'));
            window.history.replaceState({}, '', url);
        });
        self.getAverageCostOfServiceChartData({ data: { tab: 'average-cost-of-service-tab2' }, VehicleType });
        History.Adapter.bind(window, "statechange", () => self.updateAverageCostOfServiceState());
        window.updateResults = function () {
            self.updateResultsAverageCostOfServiceLogic();
        };

        // Extract tab parameter from URL
        const urlSearchParams = new URLSearchParams(window.location.search);
        let tab = urlSearchParams.get('tab');

        // If a tab parameter is found, set this tab to active. Otherwise, default to tab1
        if (tab) {
            $('#' + tab).tab('show');
        } else {
            tab = 'average-cost-of-service-tab2';
            $('#' + tab).tab('show');
        }

        $("#average-cost-of-service-tab1, #average-cost-of-service-tab2, #average-cost-of-service-tab3").on('shown.bs.tab', function (e) {
            const tab = $(this).attr('id');
            // Only fetch the chart data after the tab has been shown
            if ($('#' + tab).hasClass('active')) {
                const state = { data: { tab: tab, VehicleType: self.getParameterByName('VehicleType') } }; // Fetch FuelType from the URL
                self.getAverageCostOfServiceChartData(state);
                self.reloadTable(state); // Update to pass full state
            }
        });

        $('#' + tab).tab('show');

        // Explicitly call getChartData and reloadTable for the initial tab
        const state = { data: { tab: tab, VehicleType: self.getParameterByName('VehicleType') } }; // Fetch FuelType from the URL
        self.getAverageCostOfServiceChartData(state);
        self.reloadTable(state); // Update to pass full state


        google.charts.load('current', { 'packages': ['corechart'] });
    },
};

// Average labour rate
const AverageLabourRate = {
    history: window.History,
    buildUpQueryString: function (nv_data) {
        const queryStringData = {};
        $.map(nv_data,
            function (value, key) {
                if (key === "isPageChange")
                    return;
                if (value) {
                    queryStringData[key] = value;
                }
            });
        return $.param(queryStringData).replace(/%5B%5D/g, "");
    },

    getAverageLabourRateData: function () {
        const dataArray = $("[data-one-link-average-labour-rate-query-attributes] :input").serializeArray();
        const data = {};
        dataArray.map(function (item) {
            if (data[item.name]) {
                if (typeof (data[item.name]) === "string") {
                    data[item.name] = [data[item.name]];
                }
                data[item.name].push(item.value);
            } else {
                data[item.name] = item.value;
            }
        });

        // Get the active tab
        var tabValue = $("#average-labour-rate-tab1, #average-labour-rate-tab2, #average-labour-rate-tab3").filter(".active").attr('id');
        // Add the active tab to the data
        data.tab = tabValue;
        data.DealerType = $('#DealerType').val() || null;
        console.log("dealer type: " + data.DealerType);
        return data;
    },

    updateResultsAverageLabourRateLogic: function (isPageChange) {
        const self = this;
        const data = self.getAverageLabourRateData();
        if (isPageChange) {
            data.isPageChange = true;
        }
        self.history.pushState(data, $("title").html(), location.pathname + "?" + self.buildUpQueryString(data));
        return data;
    },

    reloadQuery: function () {
        const self = this;
        const state = self.history.getState();
        $.get('/one-link-average-labour-rate/query', state.data, function (response) {
            $('[data-one-link-average-labour-rate-query-attributes]').replaceWith(response);
        });
    },
    reloadTable: function (state) {
        const self = this;
        $.get("/one-link-average-labour-rate/table-results", state.data, function (response) {
            $('[data-one-link-average-labour-rate-table-results]').replaceWith(response);
        });
    },
    getAverageLabourRateChartData: function (state) {
        const self = this;
        $.get("/one-link-average-labour-rate/get-chart-data", state.data, function (response) {
            console.log("Inside getAverageLabourRateChartData of LabourRate");
            console.log("age: " + response);
            self.drawAverageLabourRateChartForMonths(state.data.tab, response);
        });
    },

    updateAverageLabourRateState: function () {
        const self = this;
        self.reloadQuery();
        const state = self.history.getState();
        $.get('/one-link-average-labour-rate/table-results', state.data, function (response) {
            $('[data-one-link-average-labour-rate-table-results]').replaceWith(response);
        });
        self.getAverageLabourRateChartData(self.history.getState());
    },

    drawAverageLabourRateChartForMonths: function (tab, drawAverageLabourRateChart) {
        if (googleChartsLoaded) {
            if ($('#' + tab).hasClass('active')) {
                const self = this;
                var labourRateChartId = 'curve_chart-' + tab;
                self.drawAverageLabourRateChart(labourRateChartId, drawAverageLabourRateChart);
            }
        } else {
            setTimeout(() => this.drawAverageLabourRateChartForMonths(tab, drawAverageLabourRateChart), 1000);
        }
    },

    getParameterByName: function (name, url = window.location.href) {
        name = name.replace(/[\[\]]/g, '\\$&');
        var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
            results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, ' '));
    },

    drawAverageLabourRateChart: function (labourRateChartId, rawDataAverageLabourRate) {
        const self = this;
        var columnNames = ['Month', 'Average labour rate franchised (£)', 'Average labour rate non-franchised (£)'];
        var selectedDealerType = (self.getParameterByName('DealerType') || 'all').toLowerCase();
        console.log("selected dealer type: " + selectedDealerType);
        if (selectedDealerType !== 'all') {
            var dealerTypes = ['infranchise', 'outfranchise'];
            var index = dealerTypes.indexOf(selectedDealerType);
            columnNames = ['Month', columnNames[index + 1]];
        }
        var chartData = [columnNames];

        for (var i = 0; i < rawDataAverageLabourRate.length; i++) {
            var dateParts = rawDataAverageLabourRate[i].monthYear.split(" ");
            var year = parseInt(dateParts[1]);
            var monthMapping = { Jan: 0, Feb: 1, Mar: 2, Apr: 3, May: 4, Jun: 5, Jul: 6, Aug: 7, Sept: 8, Oct: 9, Nov: 10, Dec: 11 };
            var month = monthMapping[dateParts[0]];
            var dealerTypeMapping = {
                'infranchise': 'averageInFranchiseLabourRate',
                'outfranchise': 'averageOutFranchiseLabourRate'
            };

            if (selectedDealerType === 'all') {
                chartData.push([
                    new Date(year, month),
                    rawDataAverageLabourRate[i].averageInFranchiseLabourRate ? parseFloat(rawDataAverageLabourRate[i].averageInFranchiseLabourRate.toFixed(2)) : null,
                    rawDataAverageLabourRate[i].averageOutFranchiseLabourRate ? parseFloat(rawDataAverageLabourRate[i].averageOutFranchiseLabourRate.toFixed(2)) : null
                ]);
            } else if (rawDataAverageLabourRate[i].hasOwnProperty(dealerTypeMapping[selectedDealerType])) {
                chartData.push([
                    new Date(year, month),
                    rawDataAverageLabourRate[i][dealerTypeMapping[selectedDealerType]] ? parseFloat(rawDataAverageLabourRate[i][dealerTypeMapping[selectedDealerType]].toFixed(2)) : null
                ]);
            }

        }
        var data = google.visualization.arrayToDataTable(chartData);

        var options = {
            curveType: 'none',
            vAxis: { format: '£#', minValue: 0 },
            hAxis: {
                format: 'MMM yyyy',
                slantedText: true, // Enable slanted text
                slantedTextAngle: 45, // Set the angle to 45 degrees
                ticks: data.getNumberOfRows() ? data.getDistinctValues(0) : []
            },
            legend: {
                position: 'top',
                alignment: 'start'
            },
            series: {
                0: { lineWidth: 1, pointSize: 5 },
                1: { lineWidth: 1, pointSize: 5 },
                2: { lineWidth: 1, pointSize: 5 },
                3: { lineWidth: 1, pointSize: 5 }
            },
            chartArea: {
                left: '10%',
                right: '7%',
                top: '10%',
                bottom: '15%',
                width: '100%',
                height: '82%',
                bottom: '15%'
            }
        };
        var labourRateChartDiv = document.getElementById(labourRateChartId);
        if (labourRateChartDiv) {
            // Create a chart instance
            var labourRateChart = new google.visualization.LineChart(labourRateChartDiv);

            // Clear the chart
            labourRateChart.clearChart();

            // Draw the chart with options and data.
            labourRateChart.draw(data, options);
        }
    },

    setupOneLinkAverageLabourRate: function () {
        const self = this;
        const DealerType = self.getParameterByName('DealerType');
        $(document).on("change",
            "[data-one-link-average-labour-rate-query-attributes] input, [data-one-link-average-labour-rate-query-attributes] select",
            () => self.updateResultsAverageLabourRateLogic());

        $("#average-labour-rate-tab1, #average-labour-rate-tab2, #average-labour-rate-tab3").on('click', function (e) {
            // Stop the browser from following the link
            e.preventDefault();

            // Show the tab
            $(this).tab('show');

            // Update URL
            let url = new URL(window.location.href);
            url.searchParams.set('tab', $(this).attr('id'));
            window.history.replaceState({}, '', url);
        });
        self.getAverageLabourRateChartData({ data: { tab: 'average-labour-rate-tab2' }, DealerType });
        History.Adapter.bind(window, "statechange", () => self.updateAverageLabourRateState());
        window.updateResults = function () {
            self.updateResultsAverageLabourRateLogic();
        };

        // Extract tab parameter from URL
        const urlSearchParams = new URLSearchParams(window.location.search);
        let tab = urlSearchParams.get('tab');

        // If a tab parameter is found, set this tab to active. Otherwise, default to tab1
        if (tab) {
            $('#' + tab).tab('show');
        } else {
            tab = 'average-labour-rate-tab2';
            $('#' + tab).tab('show');
        }

        $("#average-labour-rate-tab1, #average-labour-rate-tab2, #average-labour-rate-tab3").on('shown.bs.tab', function (e) {
            const tab = $(this).attr('id');
            // Only fetch the chart data after the tab has been shown
            if ($('#' + tab).hasClass('active')) {
                const state = { data: { tab: tab, DealerType: self.getParameterByName('DealerType') } }; // Fetch FuelType from the URL
                self.getAverageLabourRateChartData(state);
                self.reloadTable(state); // Update to pass full state
            }
        });

        $('#' + tab).tab('show');

        // Explicitly call getChartData and reloadTable for the initial tab
        const state = { data: { tab: tab, DealerType: self.getParameterByName('DealerType') } }; // Fetch FuelType from the URL
        self.getAverageLabourRateChartData(state);
        self.reloadTable(state); // Update to pass full state


        google.charts.load('current', { 'packages': ['corechart'] });
    },
};


// Average cost of car parts
const AverageCostOfCarParts = {
    history: window.History,
    buildUpQueryString: function (nv_data) {
        const queryStringData = {};
        $.map(nv_data,
            function (value, key) {
                if (key === "isPageChange")
                    return;
                if (value) {
                    queryStringData[key] = value;
                }
            });
        return $.param(queryStringData).replace(/%5B%5D/g, "");
    },

    getAverageCostOfCarPartsData: function () {
        const dataArray = $("[data-one-link-average-cost-of-car-parts-query-attributes] :input").serializeArray();
        const data = {};
        dataArray.map(function (item) {
            if (data[item.name]) {
                if (typeof (data[item.name]) === "string") {
                    data[item.name] = [data[item.name]];
                }
                data[item.name].push(item.value);
            } else {
                data[item.name] = item.value;
            }
        });

        // Get the active tab
        var tabValue = $("#average-cost-of-car-parts-tab1, #average-cost-of-car-parts-tab2, #average-cost-of-car-parts-tab3").filter(".active").attr('id');
        // Add the active tab to the data
        data.tab = tabValue;
        data.CarPartType = $('#CarPartType').val() || null;
        console.log("car part type: " + data.CarPartType);
        return data;
    },

    updateResultsAverageCostOfCarPartsLogic: function (isPageChange) {
        const self = this;
        const data = self.getAverageCostOfCarPartsData();
        if (isPageChange) {
            data.isPageChange = true;
        }
        self.history.pushState(data, $("title").html(), location.pathname + "?" + self.buildUpQueryString(data));
        return data;
    },

    reloadQuery: function () {
        const self = this;
        const state = self.history.getState();
        $.get('/one-link-average-cost-of-car-parts/query', state.data, function (response) {
            $('[data-one-link-average-cost-of-car-parts-query-attributes]').replaceWith(response);
        });
    },
    reloadTable: function (state) {
        const self = this;
        $.get("/one-link-average-cost-of-car-parts/table-results", state.data, function (response) {
            $('[data-one-link-average-cost-of-car-parts-table-results]').replaceWith(response);
        });
    },
    getAverageCostOfCarPartsChartData: function (state) {
        const self = this;
        $.get("/one-link-average-cost-of-car-parts/get-chart-data", state.data, function (response) {
            console.log("Inside getAverageCostOfCarPartsChartData");
            console.log("age: " + response);
            self.drawAverageCostOfCarPartsChartForMonths(state.data.tab, response);
        });
    },

    updateAverageCostOfCarPartsState: function () {
        const self = this;
        self.reloadQuery();
        const state = self.history.getState();
        $.get('/one-link-average-cost-of-car-parts/table-results', state.data, function (response) {
            $('[data-one-link-average-cost-of-car-parts-table-results]').replaceWith(response);
        });
        self.getAverageCostOfCarPartsChartData(self.history.getState());
    },

    drawAverageCostOfCarPartsChartForMonths: function (tab, drawAverageCostOfCarPartsChart) {
        if (googleChartsLoaded) {
            if ($('#' + tab).hasClass('active')) {
                const self = this;
                var costOfCarPartsChartId = 'curve_chart-' + tab;
                self.drawAverageCostOfCarPartsChart(costOfCarPartsChartId, drawAverageCostOfCarPartsChart);
            }
        } else {
            setTimeout(() => this.drawAverageCostOfCarPartsChartForMonths(tab, drawAverageCostOfCarPartsChart), 1000);
        }
    },

    getParameterByName: function (name, url = window.location.href) {
        name = name.replace(/[\[\]]/g, '\\$&');
        var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
            results = regex.exec(url);
        if (!results) return null;
        if (!results[2]) return '';
        return decodeURIComponent(results[2].replace(/\+/g, ' '));
    },

    drawAverageCostOfCarPartsChart: function (costOfCarPartsChartId, rawDataAverageCostOfCarParts) {
        const self = this;
        var columnNames = ['Month', 'Average price of front disc (including pads) (£)', 'Average price of clutch (£)', 'Average price of windscreen wiper (£)'];
        var selectedCarPartType = (self.getParameterByName('CarPartType') || 'all').toLowerCase();
        console.log("selected car part type: " + selectedCarPartType);
        if (selectedCarPartType !== 'all') {
            var carPartTypes = ['averagepriceoffrontdisc', 'averagepriceofclutch', 'averagepriceofwindscreenwiper'];
            var index = carPartTypes.indexOf(selectedCarPartType);
            columnNames = ['Month', columnNames[index + 1]];
        }
        var chartData = [columnNames];

        for (var i = 0; i < rawDataAverageCostOfCarParts.length; i++) {
            var dateParts = rawDataAverageCostOfCarParts[i].monthYear.split(" ");
            var year = parseInt(dateParts[1]);
            var monthMapping = { Jan: 0, Feb: 1, Mar: 2, Apr: 3, May: 4, Jun: 5, Jul: 6, Aug: 7, Sept: 8, Oct: 9, Nov: 10, Dec: 11 };
            var month = monthMapping[dateParts[0]];
            var carPartTypeMapping = {
                'averagepriceoffrontdisc': 'averagePriceOfFrontDisc',
                'averagepriceofclutch': 'averagePriceOfClutch',
                'averagepriceofwindscreenwiper' : 'averagePriceOfWindscreenWiper'
            };

            if (selectedCarPartType === 'all') {
                chartData.push([
                    new Date(year, month),
                    rawDataAverageCostOfCarParts[i].averagePriceOfFrontDisc ? parseFloat(rawDataAverageCostOfCarParts[i].averagePriceOfFrontDisc.toFixed(2)) : null,
                    rawDataAverageCostOfCarParts[i].averagePriceOfClutch ? parseFloat(rawDataAverageCostOfCarParts[i].averagePriceOfClutch.toFixed(2)) : null,
                    rawDataAverageCostOfCarParts[i].averagePriceOfWindscreenWiper ? parseFloat(rawDataAverageCostOfCarParts[i].averagePriceOfWindscreenWiper.toFixed(2)) : null,
                ]);
            } else if (rawDataAverageCostOfCarParts[i].hasOwnProperty(carPartTypeMapping[selectedCarPartType])) {
                chartData.push([
                    new Date(year, month),
                    rawDataAverageCostOfCarParts[i][carPartTypeMapping[selectedCarPartType]] ? parseFloat(rawDataAverageCostOfCarParts[i][carPartTypeMapping[selectedCarPartType]].toFixed(2)) : null
                ]);
            }

        }
        var data = google.visualization.arrayToDataTable(chartData);

        var options = {
            curveType: 'none',
            vAxis: { format: '£#', minValue: 0 },
            hAxis: {
                format: 'MMM yyyy',
                slantedText: true, // Enable slanted text
                slantedTextAngle: 45, // Set the angle to 45 degrees
                ticks: data.getNumberOfRows() ? data.getDistinctValues(0) : []
            },
            legend: {
                position: 'top',
                alignment: 'start'
            },
            series: {
                0: { lineWidth: 1, pointSize: 5 },
                1: { lineWidth: 1, pointSize: 5 },
                2: { lineWidth: 1, pointSize: 5 },
                3: { lineWidth: 1, pointSize: 5 }
            },
            chartArea: {
                left: '10%',
                right: '7%',
                top: '10%',
                bottom: '15%',
                width: '100%',
                height: '82%'
            }
        };
        var costOfCarPartsChartDiv = document.getElementById(costOfCarPartsChartId);
        if (costOfCarPartsChartDiv) {
            // Create a chart instance
            var costOfCarPartsChart = new google.visualization.LineChart(costOfCarPartsChartDiv);

            // Clear the chart
            costOfCarPartsChart.clearChart();

            // Draw the chart with options and data.
            costOfCarPartsChart.draw(data, options);
        }
    },

    setupOneLinkAverageCostOfCarParts: function () {
        const self = this;
        const CarPartType = self.getParameterByName('CarPartType');
        $(document).on("change",
            "[data-one-link-average-cost-of-car-parts-query-attributes] input, [data-one-link-average-cost-of-car-parts-query-attributes] select",
            () => self.updateResultsAverageCostOfCarPartsLogic());

        $("#average-cost-of-car-parts-tab1, #average-cost-of-car-parts-tab2, #average-cost-of-car-parts-tab3").on('click', function (e) {
            // Stop the browser from following the link
            e.preventDefault();

            // Show the tab
            $(this).tab('show');

            // Update URL
            let url = new URL(window.location.href);
            url.searchParams.set('tab', $(this).attr('id'));
            window.history.replaceState({}, '', url);
        });
        self.getAverageCostOfCarPartsChartData({ data: { tab: 'average-cost-of-car-parts-tab2' }, CarPartType });
        History.Adapter.bind(window, "statechange", () => self.updateAverageCostOfCarPartsState());
        window.updateResults = function () {
            self.updateResultsAverageCostOfCarPartsLogic();
        };

        // Extract tab parameter from URL
        const urlSearchParams = new URLSearchParams(window.location.search);
        let tab = urlSearchParams.get('tab');

        // If a tab parameter is found, set this tab to active. Otherwise, default to tab1
        if (tab) {
            $('#' + tab).tab('show');
        } else {
            tab = 'average-cost-of-car-parts-tab2';
            $('#' + tab).tab('show');
        }

        $("#average-cost-of-car-parts-tab1, #average-cost-of-car-parts-tab2, #average-cost-of-car-parts-tab3").on('shown.bs.tab', function (e) {
            const tab = $(this).attr('id');
            // Only fetch the chart data after the tab has been shown
            if ($('#' + tab).hasClass('active')) {
                const state = { data: { tab: tab, CarPartType: self.getParameterByName('CarPartType') } }; // Fetch CarPartType from the URL
                self.getAverageCostOfCarPartsChartData(state);
                self.reloadTable(state); // Update to pass full state
            }
        });

        $('#' + tab).tab('show');

        // Explicitly call getChartData and reloadTable for the initial tab
        const state = { data: { tab: tab, CarPartType: self.getParameterByName('CarPartType') } }; // Fetch CarPartType from the URL
        self.getAverageCostOfCarPartsChartData(state);
        self.reloadTable(state); // Update to pass full state


        google.charts.load('current', { 'packages': ['corechart'] });
    },
};

// Main entry point
$(function () {
    loadGoogleCharts().then(() => {
        const pageType = $("#PageType").val(); // Get the value of hidden field
        if (pageType === 'OneLinkAveragePriceOfWindscreenWiper') {
            AveragePriceOfWindscreenWiper.setupOneLinkAveragePriceOfWindscreenWiper();
        }
        else if (pageType === 'OneLinkAveragePriceOfClutch') {
            AveragePriceOfClutch.setupOneLinkAveragePriceOfClutch();
        }
        else if (pageType === 'OneLinkAveragePriceOfFrontDisc') {
            AveragePriceOfFrontDisc.setupOneLinkAveragePriceOfFrontDisc();
        }
        else if (pageType === 'OneLinkPercentageOfAllSMRJobsInFranchise') {
            PercentageOfAllSMRJobsInFranchise.setupOneLinkPercentageOfAllSMRJobsInFranchise();
        }
        else if (pageType === 'OneLinkAverageCostOfService') {
            //AverageCostOfService.setupOneLinkAverageCostOfService();
            AverageCostOfServiceCar.setupOneLinkAverageCostOfServiceCar();
        }
        else if (pageType === 'OneLinkAverageLabourRate') {
            AverageLabourRate.setupOneLinkAverageLabourRate();
        }
        else if (pageType === 'OneLinkAverageCostOfCarParts') {
            AverageCostOfCarParts.setupOneLinkAverageCostOfCarParts();
        }
    });
});

$(window).resize(function () {
    const pageType = $("#PageType").val();
    if (pageType === 'OneLinkAveragePriceOfWindscreenWiper') {
        const activeTab = $("#average-price-of-windscreen-wiper-tab1, #average-price-of-windscreen-wiper-tab2, #average-price-of-windscreen-wiper-tab3").filter(".active").attr('id');
        AveragePriceOfWindscreenWiper.getChartData({ data: { tab: activeTab } });
    }
    else if (pageType === 'OneLinkAveragePriceOfClutch') {
        const activeTab = $("#average-price-of-clutch-tab1, #average-price-of-clutch-tab2, #average-price-of-clutch-tab3").filter(".active").attr('id');
        AveragePriceOfClutch.getChartData({ data: { tab: activeTab } });
    }
    else if (pageType === 'OneLinkAveragePriceOfFrontDisc') {
        const activeTab = $("#average-price-of-front-disc-tab1, #average-price-of-front-disc-tab2, #average-price-of-front-disc-tab3").filter(".active").attr('id');
        AveragePriceOfFrontDisc.getChartData({ data: { tab: activeTab } });
    }
    else if (pageType === 'OneLinkPercentageOfAllSMRJobsInFranchise') {
        const activeTab = $("#percentage-of-all-smr-jobs-in-franchise-tab1, #percentage-of-all-smr-jobs-in-franchise-tab2, #percentage-of-all-smr-jobs-in-franchise-tab3").filter(".active").attr('id');
        PercentageOfAllSMRJobsInFranchise.getChartData({ data: { tab: activeTab } });
    }
    else if (pageType === 'OneLinkAverageCostOfService') {
        const activeTab = $("#average-cost-of-service-tab1, #average-cost-of-service-tab2, #average-cost-of-service-tab3").filter(".active").attr('id');
        AverageCostOfServiceCar.getChartData({ data: { tab: activeTab } });
        //AverageCostOfService.getAverageCostOfServiceChartData({ data: { tab: activeTab } });
    }
    else if (pageType === 'OneLinkAverageLabourRate') {
        const activeTab = $("#average-labour-rate-tab1, #average-labour-rate-tab2, #average-labour-rate-tab3").filter(".active").attr('id');
        AverageLabourRate.getAverageLabourRateChartData({ data: { tab: activeTab } });
    }
    else if (pageType === 'OneLinkAverageCostOfCarParts') {
        const activeTab = $("#average-cost-of-car-parts-tab1, #average-cost-of-car-parts-tab2, #average-cost-of-car-parts-tab3").filter(".active").attr('id');
        AverageCostOfCarParts.getAverageCostOfCarPartsChartData({ data: { tab: activeTab } });
    }
});
export function setupOneLinkAveragePriceOfWindscreenWiper() {
    AveragePriceOfWindscreenWiper.setupOneLinkAveragePriceOfWindscreenWiper();
}
export function setupOneLinkAveragePriceOfClutch() {
    AveragePriceOfClutch.setupOneLinkAveragePriceOfClutch();
}
export function setupOneLinkAveragePriceOfFrontDisc() {
    AveragePriceOfFrontDisc.setupOneLinkAveragePriceOfFrontDisc();
}
export function setupOneLinkPercentageOfAllSMRJobsInFranchise() {
    PercentageOfAllSMRJobsInFranchise.setupOneLinkPercentageOfAllSMRJobsInFranchise();
}
//export function setupOneLinkAverageCostOfService() {
    //AverageCostOfService.setupOneLinkAverageCostOfService();
//}

export function setupOneLinkAverageCostOfServiceCar() {
    AverageCostOfService.setupOneLinkAverageCostOfServiceCar();
}
export function setupOneLinkAverageLabourRate() {
    AverageLabourRate.setupOneLinkAverageLabourRate();
}

export function setupOneLinkAverageCostOfCarParts() {
    AverageCostOfCarParts.setupOneLinkAverageCostOfCarParts();
}